import PropTypes from "prop-types";
import React from "react";
import Textarea from "react-textarea-autosize";
import styled, { css } from "styled-components";
import { layout } from "../../../main/styles/layout";

const Seller9 = ({
  design,
  agent,
  AgentInfo,
  Title,
  Subtitle,
  PrimaryInput,
  Footer
}) => {
  const { backgroundUrl } = design;

  return (
    <LandingPageWrapper>
      <AgentInfo agent={agent} design={design} />
      <MainContent>
        <Title
          TitleWrapper={TitleWrapper}
          TitleInput={TitleInput}
          TitleText={TitleText}
          design={design}
        />
        <PrimaryInputWrapper>
          <PrimaryInput />
        </PrimaryInputWrapper>
        <Subtitle
          SubtitleWrapper={SubtitleWrapper}
          SubtitleInput={SubtitleInput}
          SubtitleText={SubtitleText}
          design={design}
        />
      </MainContent>
      <Illustration bgImg={backgroundUrl} />
      <FooterWrapper>
        <Footer
          dreNumber={agent.dreNumber}
          website={agent.website}
          design={design}
        />
      </FooterWrapper>
    </LandingPageWrapper>
  );
};

Seller9.propTypes = {
  design: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
  AgentInfo: PropTypes.elementType.isRequired,
  Title: PropTypes.elementType.isRequired,
  Subtitle: PropTypes.elementType.isRequired,
  PrimaryInput: PropTypes.elementType.isRequired,
  Footer: PropTypes.elementType.isRequired
};

// Styled Components
const LandingPageWrapper = styled.div`
  ${layout("column", "center")}
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background: linear-gradient(-180deg, #5200c5 3%, #4b84ff 96%);
`;

const MainContent = styled.div`
  width: 100%;
  max-width: 1200px;
  height: auto;
  padding: 144px 30px 0 30px;
  box-sizing: border-box;
  z-index: 1;
  @media (max-width: 599px) {
    padding: 186px 15px 0 15px;
  }
`;

const Illustration = styled.div`
  width: 100%;
  max-width: 1200px;
  min-height: 257px;
  background-repeat: no-repeat;
  background-image: ${(props) => `url(${props.bgImg})`};
  @media (max-width: 599px) {
    background-size: cover;
    background-position: center;
  }
`;

const PrimaryInputWrapper = styled.div`
  ${layout("row", "center", "center")}
  width: 100%;
`;

const FooterWrapper = styled.div`
  ${layout("row", "center", "center")}
  width: 100%;
  min-height: 100px;
`;

// Child Components passed as props
const TitleWrapper = styled.div`
  ${layout("row", "center", "center")}
  margin-bottom: 28px;
  padding: 24px 40px;
  box-sizing: border-box;
  width: 100%;
  ${(props) =>
    props.customizable &&
    css`
      width: auto;
      border: 1px dashed #00e6c3;
      &:hover {
        border: 1px solid #00e6c3;
      }
    `}
  @media (max-width: 599px) {
    width: 100%;
    margin-bottom: 30px;
    padding: 4px 8px;
  }
`;

const TitleInput = styled(Textarea)`
  font-size: 40px;
  line-height: 52px;
  font-weight: 400;
  min-height: 52px;
  font-weight: 600;
  outline: none;
  border: none;
  width: 100%;
  max-width: 1140px;
  text-align: center;
  resize: none;
  background: transparent;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 26px;
    line-height: 36px;
    font-weight: 400;
  }
`;

const TitleText = styled.h1`
  font-size: 40px;
  line-height: 52px;
  font-weight: 600;
  width: 100%;
  max-width: 1140px;
  text-align: center;
  resize: none;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 26px;
    line-height: 36px;
    font-weight: 400;
  }
`;

const SubtitleWrapper = styled.div`
  ${layout("row", "center", "center")}
  width: 100%;
  margin-bottom: 30px;
  padding: 20px 24px;
  box-sizing: border-box;
  ${(props) =>
    props.customizable &&
    css`
      width: auto;
      border: 1px dashed #00e6c3;
      &:hover {
        border: 1px solid #00e6c3;
      }
    `}
  @media (max-width: 599px) {
    padding: 0 8px;
    margin-bottom: 34px;
  }
`;

const SubtitleInput = styled(Textarea)`
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
  min-height: 20px;
  border: none;
  outline: none;
  width: 100%;
  max-width: 1140px;
  resize: none;
  text-align: center;
  background: transparent;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

const SubtitleText = styled.h1`
  font-size: 15px;
  line-height: 20px;
  width: 100%;
  max-width: 1140px;
  resize: none;
  text-align: center;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

export default Seller9;
